import type { Nullable } from "../types";

const DEFAULT_VALUE = Number(Number(0).toFixed(2));

/**
 * This function caps a float value to 2 decimal places.
 * @param value
 * @returns
 */
export function capFloat(value: Nullable<number>): number {
	if (value === null || value === undefined) return DEFAULT_VALUE;
	if (Number.isNaN(value)) return DEFAULT_VALUE;
	if (value === Number.POSITIVE_INFINITY) return DEFAULT_VALUE;
	if (value === Number.NEGATIVE_INFINITY) return DEFAULT_VALUE;
	if (value === Number.MAX_VALUE) return DEFAULT_VALUE;
	if (value === Number.MIN_VALUE) return DEFAULT_VALUE;
	return Number(Number(value).toFixed(2));
}
